export const FLOW_NAME = "profile-discovery";
export type FLOW_TYPE = "profile-discovery";

export const INPUT_DATA = "data";

export const RUN_ID = "RUN_ID";
export const INIT_RUN = "INIT_RUN";
export const CREATED_BY = "CREATED_BY";
export const TIME_STAMP = "TIME_STAMP";

export const RECIPE_NAME =
  "profile-extraction-discover-explore-and-tag-profiles";

export const ID_COLUMNS_KEY = "id-columns";
export const ATTRIBUTE_COLUMNS_KEY = "attributes";

export const ATTRIBUTE_WEIGHTS = "attribute-weights";

// Hyper Params
export const MIN_NUM_PROFILES_KEY = "min-num-profiles";
export const DEFAULT_MIN_PROFILES = 5;
export const MAX_NUM_PROFILES_KEY = "max-num-profiles";
export const DEFAULT_MAX_PROFILES = 10;
export const MIN_ID_COUNT_KEY = "min-id-count";
export const DEFAULT_MIN_ID_COUNT = 5;
export const MAX_ID_P_KEY = "max-doc-p";
export const DEFAULT_MAX_ID_P = 0.7;

// Algorithms
export const LDA_ALGO = "lda";
